import { render, staticRenderFns } from "./InputBairro.vue?vue&type=template&id=0d754773"
import script from "./InputBairro.vue?vue&type=script&lang=js"
export * from "./InputBairro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports